var _polyfillNode_crypto = {};

export default _polyfillNode_crypto;
